<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_trip_title' | translate }}</h4>
  <form #form="ngForm">
    <mat-form-field>
      <mat-label>{{ 'common_field_label' | translate }}</mat-label>
      <input matInput [(ngModel)]="data.displayName" cdkFocusInitial name="displayName" maxlength="30" required />
      <mat-hint align="end">{{ data.displayName?.length || 0 }} / 30</mat-hint>
      <mat-error *ngIf="!data.displayName" [innerHTML]="'common_error_label_required' | translate"></mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'dialog_composition_field_percentage' | translate }}</mat-label>
      <input type="number" matInput [(ngModel)]="data.ratio" name="ratio" #ratio="ngModel" min="0" max="100" step="1" pattern="^[0-9]+$" required />
      <mat-icon matSuffix>%</mat-icon>
      <mat-error *ngIf="ratio.errors?.required" [innerHTML]="'dialog_composition_error_percentage' | translate"></mat-error>
      <mat-error *ngIf="!ratio.errors?.required && (ratio.errors?.min || ratio.errors?.max || ratio.errors?.pattern)" [innerHTML]="'dialog_trip_error_ratio_whole' | translate"></mat-error>
    </mat-form-field>

    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
